import { useEffect, type ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface Props {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  children: ReactNode;
  /** Высота listа в px или 'full' */
  height?: number | 'full';
}

export function Modal({ open, onClose, title, children, height = 'full' }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            className="fixed inset-0 bg-black/40 z-40"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={onClose}
          />
          <motion.div
            className="fixed left-0 right-0 bottom-0 z-50 bg-bg rounded-t-xl shadow-lg flex flex-col safe-bottom"
            style={height === 'full' ? { height: '92vh' } : { height }}
            initial={{ y: '100%' }} animate={{ y: 0 }} exit={{ y: '100%' }}
            transition={{ type: 'spring', damping: 30, stiffness: 280 }}
          >
            {title && (
              <div className="px-4 py-3 border-b border-text/10 flex items-center justify-between">
                <div className="text-base font-medium">{title}</div>
                <button onClick={onClose} className="w-8 h-8 grid place-items-center rounded-pill hover:bg-surface" aria-label="close">×</button>
              </div>
            )}
            <div className="flex-1 overflow-y-auto">{children}</div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
